export default __webpack_public_path__ + "static/media/spolexLogoTrimmed.d96d5271.png";